import {nioJsBridge, constant, storage} from 'nioJsBridge';
import {supreme} from '@/supreme-core';
import config from '@/config/baseConfig';
import util from '../util';

const defaultQuery = {
  // https://git.nevint.com/marco-polo-android/mp-app-web/blob/dev/url.md
  // header: '{\"isShow\":false}',
  is_nav_show: false
};
const baseUrl = config.compatible.prefix + config.compatible.module;
//
const getWebUrl = (link, params) => {
  const query = { ...defaultQuery, ...params || {}};
  const {webUrl} = util.getEnvInfo();

  return `${webUrl + baseUrl + link}?${util.serialize(query)}`;
};

// 项目内页面跳转
const jump = (link, params, useNative = false, h5Jump) => {
  if (!link){
    return;
  }
  if (useNative){
    nioJsBridge.openURL({data: {url: getWebUrl(link, params)}});
  } else {
    h5Jump && h5Jump(baseUrl + link, params || {});
  }
};
// 直接跳转至项目外链接
const goto = (url, {callback = () => {}, useNative = false, onlyNative = false} = {}) => {
  if (useNative){
    nioJsBridge.openURL({data: {url: url}, callback: callback});
  } else {
    if (onlyNative){
      return;
    }
    if (url.indexOf('nio:/') > -1){
      return;
    }
    window.location.href = url;
  }
};
// 退回操作
const back = (useNative = false, h5Back) => {
  console.log(nioJsBridge);
  if (useNative){
    nioJsBridge.close();
  } else {
    h5Back && h5Back();
  }
};

export {
  jump,
  back,
  goto,
  getWebUrl
};